<script setup lang="ts">
import RexMenuV3 from '@/rex-components/RexMenuV3.vue';
import AnomalySideBarActions from '@/components/charts/utils/AnomalySideBarActions.vue';
import {
  AnomalyDataObjectType,
  GraphDataNamesEnum,
} from '@/components/Common/graph.types';
import { generateAnomalyMenuList } from '@/components/charts/utils/utils.config';
import { watch, ref, onMounted, Ref, computed } from 'vue';
import { cloneDeep, isEqual } from 'lodash';
interface Props {
  selectedItems: string[];
  anomalyList: AnomalyDataObjectType[];
}

const emit = defineEmits(['onSelect']);
const props = defineProps<Props>();
const isSortAsc: Ref<null | boolean> = ref(null);
const anomalyMenuList: Ref<AnomalyDataObjectType[]> = ref([]);
const selectedFilters: Ref<string[]> = ref([
  GraphDataNamesEnum.CRITICAL_BREACH,
  GraphDataNamesEnum.MAJOR_BREACH,
  GraphDataNamesEnum.MINOR_BREACH,
]);
watch(
  () => props.anomalyList,
  (newVal, oldVal) => {
    if (!isEqual(newVal, oldVal)) {
      anomalyMenuList.value = generateAnomalyMenuList(props.anomalyList);
    }
  },
);

onMounted(() => {
  anomalyMenuList.value = generateAnomalyMenuList(props.anomalyList);
});

function onAnomalySelect(obj) {
  const type = obj?.item?.originItemValue?.label?.props?.type;
  emit('onSelect', obj.selectedKeys, { ...obj?.item?.originItemValue, type });
}

function onSortChange(isAsc) {
  isSortAsc.value = isAsc;
}

function onFilterChange(selectedList) {
  selectedFilters.value = selectedList;
}

const getAnomaliesList = computed(() => {
  const tempMenuList = cloneDeep(anomalyMenuList.value);

  if (isSortAsc.value == true || isSortAsc.value == false) {
    tempMenuList.sort((a, b) =>
      isSortAsc.value
        ? new Date(a?.date || '').getTime() - new Date(b?.date || '').getTime()
        : new Date(b?.date || '').getTime() - new Date(a?.date || '').getTime(),
    );
  }

  return tempMenuList.filter(
    (obj) => selectedFilters.value.indexOf(obj?.sevKey || '') >= 0,
  );
});
</script>

<template>
  <div class="anmly-side-bar-container">
    <div class="anmly-side-bar-header">
      <div class="anmly-side-bar-header-text">
        {{ $t('anomalies') }}
      </div>
      <AnomalySideBarActions
        @onAnomalySort="onSortChange"
        @onAnomalyFilter="onFilterChange"
        :selectedFilters="selectedFilters"
      />
    </div>
    <RexMenuV3
      v-if="anomalyMenuList?.length > 0"
      id="anomaly-side-bar"
      :items="getAnomaliesList"
      @onSelect="onAnomalySelect"
      :selectedKeys="selectedItems"
      class="anmly-modal-side-menu"
    >
    </RexMenuV3>
    <div v-else class="anmly-side-bar-no-data-box">
      <div class="anmly-side-bar-no-data-icon">
        <BaseIcon name="noData" />
      </div>
      <div class="anmly-side-bar-no-anmly-text">
        {{ $t('noAnomaliesFound') }}
      </div>
      <div>{{ $t('anomaliesNotFoundThisTimeAndChangeDate') }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.anmly-side-bar-container {
  margin: 1rem;
  font-size: 1rem;
}
.anmly-side-bar-header {
  @include flex-center-justify(space-between);
  border-bottom: 0.063rem solid $border-primary;
  height: 6%;
}
.anmly-modal-side-menu {
  height: 94%;
  overflow-y: scroll;
  width: 18rem;
}
.anmly-side-bar-no-data-box {
  margin-top: 5rem;
  text-align: center;
  width: 18rem;
}
.anmly-side-bar-no-anmly-text {
  font-weight: 600;
}
.anmly-side-bar-no-data-icon {
  transform: scale(0.65);
}
.anmly-side-bar-header-text {
  font-weight: 600;
}
:deep(.ant-menu-item-only-child) {
  height: 100%;
  padding: 0px !important;
}
</style>
